module.exports = __webpack_public_path__ + "components/ski-hire-promo/static/ski-hire--background-90e980d82ce6be0477c65f9e2fabf340.jpg";